<template>
  <div style="text-align:left">
    <Breadcrumb style="margin: 0px 10px 20px">
        <BreadcrumbItem>版位管理</BreadcrumbItem>
    </Breadcrumb>
    <Card>
		<Form ref="form" :model="formItem" :label-width="100">
			<Row>
                <Col span="8">
                    <FormItem label="版位名称">
                        <Input v-model="formItem.placement_name"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="应用名称">
                        <Input v-model="formItem.medium_name"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <Button @click="getPlacementList(1,20,formItem.placement_name,formItem.medium_name)" style="margin-left:20px" type="primary">搜索</Button>
                </Col>
            </Row>
		</Form>
        <Button @click="handleCreate" style="margin:0px 10px 20px" type="primary">新建版位</Button>
        <Table :columns="columns" :data="data"></Table>
        <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
        <Modal
            v-model="show_modal1"
            title="修改标签"
            width='350px'
            @on-ok="okChangeLable"
            @on-cancel="cancelChangeLabel">
            <Select v-model="custom_rule_ids" style="width:300px" clearable :remote-method="remoteMethod" filterable multiple :max-tag-count="2">
                <Option v-for="label in active_labels" :value="label.custom_rule_id+''" :key="label.custom_rule_id">{{label.name}}</Option>
            </Select>
        </Modal>
        <Modal
            v-model="show_modal2"
            title="版位预览图"
            width='400px'
            style="text-align: center;">
            <el-image :src="preview_url" style="width: 300px; height: 300px" fit="contain">
                <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
        </Modal>
    </Card>
  </div>
</template>
<script>
import{placementList,deletePlacement,activeLabelList,updatePlacementLabel}from "@/request/api"
import Cookies from 'js-cookie';

export default {
    name: 'placementAdmin',
    meta:{
        keepAlive: true // 开启缓存
    },
    data() {
    return {
        role_type: 0,
        show_modal1: false,
        show_modal2: false,
        preview_url: '',
        custom_rule_ids: [],
        active_labels: [],
        selected_placement: {},
        formItem:{
            placement_name:'',
            medium_name:''
        },
        columns: [
            {
                title: "版位类型",
                key: "category",
                align: 'center'
            },
            {
                title: "应用名称",
                key: "medium_name",
                align: 'center'
            },
            {
                title: "应用id",
                key: "medium_id",
                align: 'center'
            },
            {
                title: "版位名称",
                key: "placement_name",
                align: 'center'
            },
            {
                title: "版位id",
                key: "placement_id",
                align: 'center'
            },
            {
                title: "版位尺寸",
                key: "size",
                align: 'center'
            },
            {
                title: "标签",
                key: "labels",
                align: 'center',
                render: (h, { row } ) => {
                    return h('span', {}, row.labels.map((item,index)=>{return item.name}).join(","))
                },
            },
            {
                title: "备注",
                key: "remark",
                align: 'center'
            },
            {
                title: "创建者",
                key: "user_name",
                align: 'center'
            },
            {
                title: "创建日期",
                key: "created_at",
                align: 'center'
            },
            {
                title: "操作",
                key: "action",
                align: 'center',
                width: 150,
                render: (h, params) => {
                    return h("div", [
                        h("Button", {
                            style: {
                                display: this.role_type == 1 || this.role_type == 3 ? '' : 'none'
                            },
                            props: {
                                type: "text",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    this.$router.push({
                                        name: "editPlacement",
                                        query: {
                                            placement_id: params.row.placement_id,
                                        },
                                    });
                                },
                            },
                        },"编辑"),
                        h("Button",{
                            style: {
                                display: this.role_type == 1 ? '' : 'none'
                            },
                            props: {
                                type: "text",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                this.$Modal.confirm({
                                    title: "提示",
                                    content: "是否删除该项？",
                                    onOk: () => {
                                        deletePlacement({placement_id:params.row.placement_id}).then(res=>{
                                            if(res.data.code==200){
                                                this.$Message.success('删除成功');
                                                this.getPlacementList(this.page,20,this.formItem.placement_name,this.formItem.medium_name)
                                            }
                                        })
                                    },
                                });
                                },
                            },
                        },"删除"),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                this.$router.push({
                                    name: "placementStatistics",
                                    query: {
                                        placement_id: params.row.placement_id,
                                    },
                                });
                                },
                            },
                        },"查看数据统计"),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            style:{
                            },
                            on: {
                                click: () => {
                                    this.show_modal1 = true
                                    this.selected_placement = params.row
                                    this.custom_rule_ids = params.row.labels.map((item,index)=>{return item.custom_rule_id + ''})
                                },
                            },
                        },'修改标签'),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            style:{
                            },
                            on: {
                                click: () => {
                                    this.show_modal2 = true
                                    this.preview_url = params.row.preview_url
                                },
                            },
                        },'查看版位预览图')
                    ]);
                },
            }],
            data: [],
            total_count:0,
            page:1,
        };
    },
    methods: {
        getActiveLabelList(keyword, page_size){
            activeLabelList({keyword, page_size}).then(res=>{
                if(res.data.code==200){
                    this.active_labels=res.data.data.rules
                }
            })
        },
        getPlacementList(page=1,page_size=20,placement_name='',medium_name=''){
            placementList({page,page_size,placement_name,medium_name}).then(res=>{
                if(res.data.code==200){
                    this.data=res.data.data.placements
                    this.total_count=res.data.data.total
                    this.page = page
                }
            })
        },
        changePage(page){
            this.getPlacementList(page,20,this.formItem.placement_name,this.formItem.medium_name)
            this.page=page
        },
        handleCreate(){
            this.$router.push({
                name: "createPlacement",
            });
        },
        okChangeLable(){
            updatePlacementLabel({
                placement_id: this.selected_placement.placement_id,
                custom_rule_ids: this.custom_rule_ids.join(',')
            }).then(res=>{
                if(res.data.code==200){
                    this.$Message.success('Success');
                    this.getPlacementList(1,20,this.formItem.placement_name,this.formItem.medium_name)
                }else{
                    this.$Message.success(res.data.msg);
                }
                this.selected_placement = {}
            })
            this.selected_placement = {}
            this.custom_rule_ids = []
        },
        cancelChangeLabel(){
            this.selected_placement = {}
            this.custom_rule_ids = []
        },
        remoteMethod (query) {
            if (query !== '' || query == null) {
                getActiveLabelList(
                    {
                        keyword: this.keyword
                    }
                ).then(res => {
                    if (res.data.code==200){
                        const list = res.data.data.rules
                        this.active_labels = list.filter(item => item.name.indexOf(query) > -1);
                    }else{
                        this.$Message.error(res.data.msg)
                    }
                })
            } else {
                this.active_labels = []
            }
            console.log(query);
            if (query !== '' || query == null) {
                this.getActiveLabelList(query)
            } else {
                this.getActiveLabelList('')
            }
        },
    },
    created() {
        let userInfo = Cookies.get('userInfo')
        if (userInfo){
            this.role_type = JSON.parse(userInfo).role_type
        }
        this.getPlacementList(1,20,this.formItem.placement_name,this.formItem.medium_name)
        Cookies.set('active_name', '4');
        this.getActiveLabelList('')
    },
    activated() {
        // 在这里刷新列表
        this.getPlacementList(this.page,20,this.formItem.placement_name,this.formItem.medium_name)
    },
};
</script>


// WEBPACK FOOTER //
// src/views/Placement/PlacementHome.vue